import { render, staticRenderFns } from "./DictationDialog.vue?vue&type=template&id=0fe99b55&scoped=true"
import script from "./DictationDialog.vue?vue&type=script&lang=js"
export * from "./DictationDialog.vue?vue&type=script&lang=js"
import style0 from "./DictationDialog.vue?vue&type=style&index=0&id=0fe99b55&prod&scoped=true&lang=css"
import style1 from "./DictationDialog.vue?vue&type=style&index=1&id=0fe99b55&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe99b55",
  null
  
)

export default component.exports